import { MessageIn } from "../MessageIn.js";
import type { MessageIOContext } from "../MessageIOContext.js";
import { readJsonDict, readJsonString } from "../../../util/json.js";
import { APIGameAnalysis } from "./APIGameAnalysis.js";


export class MessageInAnalysedGame extends MessageIn {
    public gameID: string | null = null;
    public analysis: APIGameAnalysis | null = null;

    read(_context: MessageIOContext, json: Record<string, any>): void {
        this.gameID = readJsonString(json, "game_id");
        this.analysis = APIGameAnalysis.parse(readJsonDict(json, "analysis"));
    }
}
